import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import CareersHero from "@/components/landing/careers/CareersHero";
import CareersValues from "@/components/landing/careers/CareersValues";
import CareersPerks from "@/components/landing/careers/CareersPerks";
import CareersJobList from "@/components/landing/careers/CareersJobList";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const Careers = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="karriere" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Karriere bei Chathero – Jobs in AI & SaaS",
          "Werde Teil von Chathero und gestalte die Zukunft der KI-Kommunikation. Offene Stellen in Sales, Marketing, Engineering und mehr.",
          "/karriere",
          [
            { name: "Home", url: "/" },
            { name: "Karriere", url: "/karriere" },
          ]
        ),
      ]} />
      <LLMMetadataHead
        title="Karriere bei Chathero – Jobs in AI & SaaS | Chathero"
        description="Werde Teil von Chathero und gestalte die Zukunft der KI-Kommunikation. Offene Stellen in Sales, Marketing, Engineering und mehr. Remote-first Kultur."
        keywords="Chathero Jobs, AI Startup Jobs, SaaS Sales Jobs München, Remote Jobs Deutschland, Karriere KI"
        canonicalUrl="https://chathero.ai/karriere"
        aiCategory="Karriere, Jobs, Stellenangebote"
        aiEntityType="Careers Page"
      />
      <Header />
      <main>
        <CareersHero />
        <CareersValues />
        <CareersPerks />
        <CareersJobList />
      </main>
      <Footer />
    </div>
  );
};

export default Careers;
